module.exports = __webpack_public_path__ + "static/media/ORDERING-RECEIVING.fca65fda.svg";